<template>
  <div class="form-rows" style="margin-bottom: 20px;">
    <div class="card-title">
      直播记录
      <template>
        <el-link type="primary" icon="el-icon-refresh" @click="getList(false)"
                 style="margin-left: 10px;margin-right: 10px;">
          刷新
        </el-link>
        <el-link v-permission="'live_guarantee__claim'" v-if="isDoneOrder===0" type="primary" icon="el-icon-s-claim"
                 @click="toClaim">
          认领
        </el-link>
        <el-link v-permission="'live_guarantee__record_add'" v-if="isDoneOrder===1" type="primary" icon="el-icon-plus"
                 style="margin-left: 10px" title="添加记录" @click="handleAdd"/>
      </template>
    </div>
    <div class="form-card">
      <ml-table ref="liveGuarantee" :api="liveGuaranteeTheOrderRecords" :search="{order_id: orderId}" show-summary height="200px"
                :page-size="5">
        <template slot="columns">
          <el-table-column label="状态" width="120" align="center">
            <template v-slot="{row:{status}}">
              <span v-if="status===1" style="color: darkred">待财务确认</span>
              <span v-else style="color: olivedrab">已确认</span>
            </template>
          </el-table-column>
          <el-table-column label="直播时间" width="120" align="center">
            <template v-slot="{row:{date_live}}">
              <span>{{ date_live|parseTime('{y}年{m}月') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="核算归属" width="120" align="center">
            <template v-slot="{row:{date_check}}">
              <span>{{ date_check|parseTime('{y}年{m}月') }}</span>
            </template>
          </el-table-column>
          <el-table-column label="平台" prop="platform" width="120" align="center"/>
          <el-table-column label="红人" prop="artist_name" width="120" align="center" show-overflow-tooltip/>
          <el-table-column label="直播佣金率" width="120" header-align="center" align="center">
            <template v-slot="{row:{commission_rate}}">
              {{ commission_rate|numberFormat(2) }}%
            </template>
          </el-table-column>
          <el-table-column label="直播场次" prop="live_session" width="120" align="center"/>
          <el-table-column label="店铺名称" prop="shop_name" width="120" align="center" show-overflow-tooltip/>
          <el-table-column label="直播机制" prop="live_sm" width="120" align="center"/>
          <el-table-column label="直播销售数量" prop="sales_volume" width="120" header-align="center" align="center"/>
          <el-table-column prop="settlement_amount" label="直播GMV" width="120" header-align="center" align="center">
            <template v-slot="{row:{settlement_amount}}">
              {{ settlement_amount|numberFormat(2) }}
            </template>
          </el-table-column>
          <el-table-column label="主次推情况" prop="live_promotion" width="160" align="center"/>
          <el-table-column label="操作" width="160" align="center">
            <template v-slot="{row:{id,status,is_manually_add}}">
              <el-link v-permission="'live_guarantee__un_claim'" v-if="status===1&&is_manually_add==='N'" type="primary"
                       @click="handleDelete([id])" icon="el-icon-delete"/>
              <el-link v-permission="'live_guarantee__manually_add_by_delete'"
                       v-if="isDoneOrder===1&&status===2&&is_manually_add==='Y'" type="primary"
                       @click="handleManuallyAddByDelete(id)" icon="el-icon-delete"/>
            </template>
          </el-table-column>
        </template>
      </ml-table>
    </div>

    <el-dialog title="添加直播信息" :visible.sync="recordAdd.show" width="600px" center custom-class="live-data-dialog">
      <div class="form-card-box">
        <el-form ref="form" :model="recordAdd.formData">
          <el-form-item label="核算月份" :prop="'date_check'" required>
            <el-date-picker
                v-model="recordAdd.formData.date_check"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择核算月份">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="红人昵称" :prop="'artist_id'" label-width="120" required>
            <select-artist :value.sync="recordAdd.formData.artist_id"  :name.sync="recordAdd.formData.artist_name"/>
          </el-form-item>
          <el-form-item label="平台名称" :prop="'platform'" required>
            <el-input class="el-input-c" v-model="recordAdd.formData.platform" placeholder="平台名称" clearable
                      maxlength="100"
                      show-word-limit/>
          </el-form-item>
          <el-form-item label="直播GMV" :prop="'settlement_amount'" required>
            <el-input class="el-input-c"
                      oninput="value=value.replace(/[^\d^\.^\-]/g,'')"
                      v-model="recordAdd.formData.settlement_amount" placeholder="直播GMV（2位小数）"
                      clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="店铺名称" :prop="'shop_name'">
            <el-input class="el-input-c" v-model="recordAdd.formData.shop_name" placeholder="店铺名称" clearable
                      maxlength="128"
                      show-word-limit/>
          </el-form-item>
          <el-form-item label="直播时间" :prop="'date_live'">
            <el-date-picker
                v-model="recordAdd.formData.date_live"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择直播日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recordAdd.show = false">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <!--  直播进度  -->
    <live-data-schedule :key="scheduleKey" :order-id="orderId" style="margin-top: 20px;"/>
    <!--  手   动  -->
    <live-data-manually v-if="isDoneOrder===1" :key="'manually'+manuallyKey" :order-id="orderId" style="margin-top: 20px;"/>
  </div>
</template>
<script>
import {
  liveGuaranteeManuallyAddByDelete,
  liveGuaranteeRecordAdd,
  liveGuaranteeTheOrderRecords,
  liveGuaranteeUnClaim
} from "../../../../api/liveGuarantee";
import LiveDataSchedule from "./LiveDataSchedule";
import LiveDataManually from "./LiveDataManually";
import MlTable from "../../../../components/MlTable/index";
import {getFBoyOption} from "@/api/fboy";
import SelectArtist from "@/components/Selects/artist.vue";

export default {
  name: "LiveDataMoney",
  components: {SelectArtist, MlTable, LiveDataSchedule, LiveDataManually},
  props: {
    orderId: {
      type: [String, Number],
      required: true
    },
    orderNo: {
      type: [String],
      required: true
    },
    artistId: {
      type: [String, Number]
    },
    isDoneOrder: {
      type: [String, Number]
    }
  },
  data() {
    return {
      loading: false,
      table: [],
      scheduleKey: new Date().getTime() + '',
      manuallyKey: new Date().getTime() + '',
      recordAdd: {
        show: false,
        formData: {
          // id: null,
          // order_id: null,
          // order_no: '',
          date_live: null,
          date_check: null,
          artist_id: null,
          artist_name: '',
          platform: '',
          shop_name: '',
          settlement_amount: 0,
        },
        rules: {
          date_check: [{required: true, message: '请选择核算月份', trigger: 'change'}],
          artist_id: [{required: true, message: '请选择红人', trigger: 'change'}],
          platform: [{required: true, message: '请填写平台名称', trigger: 'change'}],
          settlement_amount: [{required: true, message: '请填写直播GMV', trigger: 'change'}],
        },
      },
      artistOption: [],
    }
  },
  // created() {
  //   this.getList()
  // },
  methods: {
    liveGuaranteeTheOrderRecords,
    getList: async function (create_key = true) {
      // this.loading = true
      // const {model} = await liveGuaranteeTheOrderRecords({order_id: this.orderId})
      // this.loading = false
      // this.table = model || []
      this.$refs.liveGuarantee.handleSearch()
      let key = new Date().getTime() + ''
      if(create_key) {
        this.scheduleKey = key
      }
      this.manuallyKey = key
    },
    toClaim: function () {
      const {href} = this.$router.resolve({
        name: `OrderLiveGuaranteeListClaim`,
        query: {order_no: this.orderNo, artist_id: this.artistId}
      });
      window.open(href, "_blank");
    },
    handleDelete: function (ids) {
      this.$msgbox.confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {success} = await liveGuaranteeUnClaim({ids})
        if (success) {
          this.$message.success('删除成功！')
          await this.getList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleChange(val) {
      let option = this.$refs['refKolSelect'].getValNode(val)
      this.recordAdd.formData.artist_name = option.nickname || ''
    },
    //红人
    getFBoySelectList() {
      try {
        if (this.artistOption.length === 0) {
          getFBoyOption({}).then((_list) => {
            if (Array.isArray(_list.model) && _list.model.length > 0) {
              this.artistOption = _list.model
            }
          });
        }
        // eslint-disable-next-line
      } catch (error) {
      }
    },
    handleClose() {
      this.recordAdd.formData = {
        date_live: null,
        date_check: null,
        artist_id: null,
        artist_name: '',
        platform: '',
        shop_name: '',
        settlement_amount: 0,
      }
      this.recordAdd.show = false
      this.getList()
    },
    handleAdd() {
      this.recordAdd.formData = {
        date_live: null,
        date_check: null,
        artist_id: null,
        artist_name: '',
        platform: '',
        shop_name: '',
        settlement_amount: 0,
      }
      this.recordAdd.show = true
    },
    onSubmit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          this.onSubmitLoading = true
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    formSubmit() {
      this.recordAdd.formData['order_id'] = this.orderId
      this.recordAdd.formData['order_no'] = this.orderNo
      liveGuaranteeRecordAdd(this.recordAdd.formData).then((res) => {
        if (res.success) {
          this.showToast({
            h: this,
            text: '保存成功'
          });
          this.handleClose()
        }

      })
    },
    handleManuallyAddByDelete: function (id) {
      this.$msgbox.confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const {success} = await liveGuaranteeManuallyAddByDelete(id)
        if (success) {
          this.$message.success('删除成功！')
          await this.getList()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__content {
  margin-left: 10px !important;
}

.form-card-box {
  border-radius: 6px;
  border: 1px solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding: 10px 20px;
}
</style>
<style lang="scss">
.live-data-dialog {
  .el-input, .el-select {
    width: calc(100% - 120px);
  }

  .el-select {
    .el-input {
      width: 100%;
    }
  }
}
</style>

